<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->

@if (link) {

    <div class="info-window-flex-row">
        <span class="label-small">Type:</span>
        <div class="control">
            <sui-select-enum-component
                    [config]="linkTypeConfig"
                    [readonly]="!historyService.isEditModeEnabled || link.isUserForced() || link.getLinkIsDisabled()"
            ></sui-select-enum-component>
        </div>
    </div>

    @if (historyService.isEditModeEnabled) {
        @if (link.isUserForced()) {
            <sui-action-component [config]="unfreezeAction"/>
        } @else {
            @if (disableAction) {
                <sui-action-component [config]="disableAction"/>
            }
            <sui-action-component [config]="deleteAction"/>
        }
    }
}

